import { useEffect } from "react";
import "./Bridge.css";

const WEB_PAGE_PATH = "/bokiori";

// 복이오리 앱 딥링크 스킴 (앱의 Info.plist / AndroidManifest 와 일치해야 함)
const DEEP_LINK_SCHEME = "bokioryshare://bridge";
const APPLE_STORE_URL =
  "https://apps.apple.com/kr/app/%EB%B3%B5%EC%9D%B4%EC%98%A4%EB%A6%AC/id6762187179";
const ANDROID_PACKAGE = "com.goldttak.bokiory_app";
const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

const OG_TITLE = "시간 투자 대비 초고소득 앱테크 - 복이오리";
const OG_DESCRIPTION =
  "앱테크 최대 보상, 현금과 1대1 비율, 특별응모권까지 다양한 혜택이 존재하는 복이오리, 지금 바로 시작하고 다양한 혜택 받아가세요";
const OG_IMAGE_PATH = "/bokiori-assets/bokiori_thumbnail.png";

// 초대코드를 Play 설치 referrer로 전달 (앱이 설치 후 Install Referrer API로 읽음)
function getGooglePlayUrl() {
  const inviteCode = new URLSearchParams(window.location.search).get(
    "inviteCode"
  );
  if (!inviteCode) return GOOGLE_PLAY_URL;
  const referrer = encodeURIComponent(`inviteCode=${inviteCode}`);
  return `${GOOGLE_PLAY_URL}&referrer=${referrer}`;
}

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function BokioriBridge() {
  const goWebPage = () => {
    const queryString = window.location.search;
    window.location.href = queryString
      ? `${WEB_PAGE_PATH}${queryString}`
      : WEB_PAGE_PATH;
  };

  // 모바일 앱 딥링크 처리, 앱이 없으면 스토어로 이동
  const openApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);

    if (!isIOS && !isAndroid) {
      // 데스크톱에서는 복이오리 소개 페이지로 이동
      goWebPage();
      return;
    }

    // URL 파라미터 유지 (userKey 등)
    const queryString = new URLSearchParams(window.location.search).toString();
    const deepLink = queryString
      ? `${DEEP_LINK_SCHEME}?${queryString}`
      : DEEP_LINK_SCHEME;
    if (isAndroid) {
      // Android: intent:// 로 열면 앱이 없을 때 브라우저가 직접 Play Store(fallback)로 이동
      // (커스텀 스킴은 앱이 없으면 에러 페이지로 바뀌거나 무시되어 스토어 이동이 실패함)
      const fallbackUrl = encodeURIComponent(getGooglePlayUrl());
      const query = queryString ? `?${queryString}` : "";
      window.location.href =
        `intent://bridge${query}#Intent;scheme=bokioryshare;` +
        `package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallbackUrl};end`;
      return;
    }

    // iOS: 앱이 열리면 페이지가 백그라운드로 감(visibilitychange / pagehide).
    // 앱이 없으면 Safari "주소가 유효하지 않음" 알림만 뜨고 페이지는 그대로이므로 App Store로 이동.
    // (blur / hasFocus는 이 알림 때문에 '앱 열림'으로 오판되므로 사용하지 않음)
    let appOpened = false;
    const markOpened = () => {
      if (document.hidden) appOpened = true;
    };
    const handlePageHide = () => {
      appOpened = true;
    };

    document.addEventListener("visibilitychange", markOpened);
    window.addEventListener("pagehide", handlePageHide);

    window.location.href = deepLink;

    setTimeout(() => {
      document.removeEventListener("visibilitychange", markOpened);
      window.removeEventListener("pagehide", handlePageHide);

      if (!appOpened && !document.hidden) {
        window.location.href = APPLE_STORE_URL;
      }
    }, 2500);
  };

  useEffect(() => {
    const prevTitle = document.title;
    document.title = OG_TITLE;
    upsertMeta("property", "og:title", OG_TITLE);
    upsertMeta("property", "og:description", OG_DESCRIPTION);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "description", OG_DESCRIPTION);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", OG_TITLE);
    upsertMeta("name", "twitter:description", OG_DESCRIPTION);

    if (OG_IMAGE_PATH) {
      const imageUrl = `${window.location.origin}${OG_IMAGE_PATH}`;
      upsertMeta("property", "og:image", imageUrl);
      upsertMeta("name", "twitter:image", imageUrl);
    }

    return () => {
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      openApp();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bridge-container">
      <div className="bridge-content">
        <h1 className="bridge-title">앱을 여는 중...</h1>
        <p className="bridge-message">잠시만 기다려주세요.</p>
        <button className="bridge-button" onClick={openApp}>
          앱 바로가기
        </button>
      </div>
    </div>
  );
}

export default BokioriBridge;
